<template>
  <div class="container p-3 bg-white shadow border-radius--bottom">
    <div class="row w-100 m-0">
      <div
        v-for="row in rowElements"
        :key="row.icon"
        class="col-12 row-card"
        :class="row.click == null ? 'pointer-none' : ''"
      >
        <Link
          class="body-1 hovered bord-bott mb-2 mt-2"
          color="none"
          color-icon="orange"
          :icon="row.icon"
          :text="row.text != undefined ? row.text : ''"
          :with-border="false"
          @click="$eventHandler(row.click)"
        />
      </div>
    </div>
    <div v-if="$slots['section-middle']" class="row w-100 m-0 mb-2">
      <div class="col-12">
        <slot name="section-middle" />
      </div>
    </div>
    <div class="row w-100 m-0">
      <div
        v-for="action in rowActions"
        :key="action.icon"
        class="col-12 row-card"
      >
        <Link
          class="body-1 hovered bord-bott mb-2 mt-2"
          :icon="action.icon"
          :text="action.text != undefined ? action.text : ''"
          @click="$eventHandler(action.click)"
        />
      </div>
    </div>
    <div class="row w-100 m-0 mt-2">
      <div class="col-12">
        <slot name="section-bottom" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    rowElements: {
      type: Array,
      default: () => [],
    },
    rowActions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import './../../scss/config/colors.scss';
@import './../../scss/mixins/layouts.scss';

.container {
  @include paddingX(1%);
}

.row .col-12:last-child .bord-bott {
  padding-bottom: 0.7em;
  margin-bottom: 0 !important;
  border-bottom: 1px map-get($colors, 'gray-5') solid;
}

.hovered:hover {
  background-color: darken(map-get($colors, 'white'), 5);
}

.row-card:hover {
  background-color: map-get($colors, 'gray-9');
}
</style>
